/* eslint-disable max-lines-per-function */
import "./contactus-address-confirmation.scss";

const showNewAddressTextarea = () => {
  const $addressAnswersRadios = document.querySelectorAll(
    ".js-address-confirmation-address-answer"
  );
  const newAddressAnswers = [
    "Yes, but ship a replacement to a new address",
    "No, that is not the correct address"
  ];
  const newAddressInputWrapper = document.querySelector(
    ".js-address-confirmation-new-shipping-address"
  );
  const newAddressInput = document.querySelector(
    ".js-address-confirmation-new-shipping-address-input"
  );

  $addressAnswersRadios.forEach(radio => {
    radio.addEventListener("change", event => {
      const isEnterNewAddress = newAddressAnswers.includes(event.target.value);
      newAddressInputWrapper.classList.toggle("hidden", !isEnterNewAddress);

      if (isEnterNewAddress) {
        newAddressInput.setAttribute("required", "required");
      } else {
        newAddressInput.removeAttribute("required");
      }
    });
  });
};

const toggleOrderInfo = () => {
  const $toggles = document.querySelectorAll(".js-address-confirmation-toggle-order-info");

  $toggles.forEach($element => {
    const $toggle = $element;
    $toggle.addEventListener("click", () => {
      $toggle.classList.toggle("show-info");
      $toggle.ariaExpanded = !($toggle.ariaExpanded === "true");
    });
  });
};

const validateAddressSelection = () => {
  const $checkboxes = document.querySelectorAll(".js-address-confirmation-address-option");
  const $customOrderTextarea = document.querySelector(".js-address-confirmation-custom-order");

  const updateRequiredState = () => {
    const hasCustomText = $customOrderTextarea.value.trim() !== "";
    const hasSelectedCheckbox = Array.from($checkboxes).some(checkbox => checkbox.checked);
    const shouldRequireCheckbox = !hasCustomText && !hasSelectedCheckbox;

    $checkboxes.forEach(checkbox => {
      if (shouldRequireCheckbox) {
        checkbox.setAttribute("required", "required");
      } else {
        checkbox.removeAttribute("required");
      }
    });
  };

  $customOrderTextarea.addEventListener("input", () => {
    updateRequiredState();
  });

  $checkboxes.forEach(checkbox => {
    checkbox.addEventListener("change", () => {
      updateRequiredState();
    });
  });
};

const showRefundNote = () => {
  const $addressAnswersRadios = document.querySelectorAll(
    ".js-address-confirmation-address-answer"
  );
  const $refundNotes = document.querySelectorAll(".js-address-confirmation-refund-note");

  $addressAnswersRadios.forEach(radio => {
    radio.addEventListener("change", event => {
      $refundNotes.forEach(refundNote => {
        const $label = refundNote.closest("label");
        const associatedInputId = $label?.getAttribute("for");
        const isSelectedRefundOption = associatedInputId === event.target.id;
        refundNote.classList.toggle("hidden", !isSelectedRefundOption);
      });
    });
  });
};

export default () => {
  showNewAddressTextarea();
  toggleOrderInfo();
  validateAddressSelection();
  showRefundNote();
};
